import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ components: {} })
export default class SuggestionSource extends Vue {
  @Prop() private source!: any;
}
